import { Can } from "@/casl-provider";
import type { CasaviSettingsUpdateBody } from "@/common/api/casavi/settings/use-casavi-settings-update.mutation";
import { Label } from "@/components/ui/label";
import { Loader, LoaderSize, LoaderVariant } from "@/components/ui/loader";
import { Switch } from "@/components/ui/switch";
import type { ReactElement } from "react";

export type ToggleSettingField = keyof Pick<CasaviSettingsUpdateBody, "cronEnabled" | "runOnStartup" | "dryRun">;

export interface ToggleSettingRowProps {
  checked: boolean;
  description: string;
  field: ToggleSettingField;
  id: string;
  isPending: boolean;
  label: string;
  onToggle: (field: ToggleSettingField, value: boolean) => Promise<void>;
}

export function ToggleSettingRow({
  checked,
  description,
  field,
  id,
  isPending,
  label,
  onToggle,
}: ToggleSettingRowProps): ReactElement {
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="min-w-0 space-y-1">
        <Label className="text-sm font-medium" htmlFor={id}>
          {label}
        </Label>
        <p className="text-muted-foreground text-xs">{description}</p>
      </div>
      <Can I="update" a="CasaviSettings">
        <div className="flex shrink-0 items-center gap-2">
          {isPending ? <Loader size={LoaderSize.Small} variant={LoaderVariant.Wheel} /> : null}
          <Switch
            id={id}
            checked={checked}
            onCheckedChange={(checkedValue) => void onToggle(field, checkedValue)}
            disabled={isPending}
          />
        </div>
      </Can>
      <Can not I="update" a="CasaviSettings">
        <Switch id={id} checked={checked} disabled className="shrink-0" />
      </Can>
    </div>
  );
}
